/** @jsxImportSource @emotion/react */
"use client";

import { forwardRef } from "react";

import { constantSemanticColors } from "../../../../../../global/emotion";
import { MoveIcon } from "../../../../../components/_base/icons/Icon/NavigationIcons";
import type { HallowElementProps } from "../../../../../types/hallowElementProps.types";

export type QueueHandleProps = HallowElementProps<"button">;

export const QueueHandle = forwardRef<HTMLButtonElement, QueueHandleProps>(
  (props, ref) => (
    <button ref={ref} onClick={(e) => e.stopPropagation()} {...props}>
      <MoveIcon color={constantSemanticColors.onColorVeryHigh} />
    </button>
  ),
);

QueueHandle.displayName = "QueueHandle";
